/**
 * Centralized TanStack Query keys — one source of truth for caching &
 * invalidation. Keys are hierarchical so related data can be invalidated together.
 */
export const queryKeys = {
  session: ['session'] as const,
  profile: (userId: string) => ['profile', userId] as const,

  articles: {
    all: ['articles'] as const,
    list: (filters?: Record<string, unknown>) => ['articles', 'list', filters ?? {}] as const,
    published: ['articles', 'published'] as const,
    detail: (slug: string) => ['articles', 'detail', slug] as const,
    mine: ['articles', 'mine'] as const,
    pending: ['articles', 'pending'] as const,
  },

  comments: (articleId: string) => ['comments', articleId] as const,
  reactions: (articleId: string) => ['reactions', articleId] as const,
  saves: ['saves'] as const,
  save: (articleId: string) => ['save', articleId] as const,
  subscribers: ['subscribers'] as const,
  writers: ['writers'] as const,
  siteSettings: ['siteSettings'] as const,
  notificationPrefs: (userId: string) => ['notificationPrefs', userId] as const,
} as const;
